import gql from 'graphql-tag';

export const getControllerNoteCategories = gql`
  query getControllerNoteCategories {
    getControllerNoteCategories {
      id
      name
    }
  }
`;
